// extracted by mini-css-extract-plugin
export var section = "styles-module--section--1vgoc";
export var inner = "styles-module--inner--2-pSt";
export var header = "styles-module--header--3pZ2N";
export var title = "styles-module--title--2vTTf";
export var list = "styles-module--list--1XOTN";